module.exports = __webpack_public_path__ + "img/noGoods.40182428.png";